import { Box } from '@mui/material'
import { Page } from 'Common/Page/Page'
import { PageHeader } from 'Common/Supplyvue-ui'
import { SORWorkcentreSummaryTable } from './SORWorkCentreSummary.table'
import { useParams, useNavigate } from 'react-router-dom'
import { useSORWorkCentreSummary } from './SORWorkCentreSummary.data'
import { useBreadcrumbsData } from 'Common/Breadcrumbs/Breadcrumbs.data'
import { SORWorkcentreSummaryType } from './SORWorkCentreSummary.types'
import { OPERTAUIONAL_PLAN_STATUS } from 'Common/Constants/Constants'

export const SORWorkcentreSummaryPage = () => {
  const navigate = useNavigate()
  const { monday } = useParams<{ monday: string }>()
  const { data, isLoading } = useSORWorkCentreSummary(monday)

  useBreadcrumbsData({
    plan_id: '',
  })
  const handleRowClick = (row: SORWorkcentreSummaryType) => {
    const { originalPlanId, workCentreKey, status, siteKey } = row
    if (
      status === OPERTAUIONAL_PLAN_STATUS.PUBLISHED &&
      originalPlanId &&
      siteKey &&
      workCentreKey
    ) {
      navigate(
        `/plan/${originalPlanId}/sourcesite/${siteKey}/workcentre/${workCentreKey}/`
      )
    }
  }

  return (
    <Page>
      <Box display="flex" flexDirection="column" flex={1}>
        <PageHeader title="SOR workcentre summary" />
        <Box>
          <SORWorkcentreSummaryTable
            data={data ?? []}
            isLoading={isLoading}
            handleRowClick={handleRowClick}
          />
        </Box>
      </Box>
    </Page>
  )
}
